import React, { Component } from 'react'

import classes from './SetupCriteria.scss'
import {
  checkValidity,
  updateFormOptions,
  updateFilterOptions,
  getSelectvalue,
  getPageStatus,
  updateObject,
  extractFilterOptions
} from '../../../../helpers/utils'
import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'
import lodash from 'lodash'
import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Button from '../../../../components/UI/Button/Button'
import Alert from '../../../../components/Alert/Alert'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import DataTable from '../../../../components/DataTable/DataTable'
import FilterBar from '../../../../components/FilterBar/FilterBar'
import Form from '../../../../components/PageContent/SetupData/SetupCriteria/Form/Form'
import Modal from '../../../../components/UI/Modal/Modal'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import SetWeight from './SetWeight/SetWeight'
import { Edit, Delete, Add } from '@material-ui/icons'
import { withTranslate } from 'react-redux-multilingual'
import moment from 'moment'
class SetupCriteria extends Component {
  state = {
    modalOpen: false,
    confirmationModalOpen: false,
    filterModalOpen: false,
    action: 'add',
    actionRecordId: null,
    formIsValid: false,
    searchText: '',
    withSeq: true,
    filter: {},
    inputGroups: {
      criteria_name: {
        label: this.props.translate('criteriaName'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('criteriaName')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      company_id: {
        label: this.props.translate('company'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: 'Select Company',
          options: [
            {
              value: '',
              label: this.props.translate('select') + this.props.translate('company')
            }
          ]
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      appraisal_type_id: {
        label: this.props.translate('appraisalType'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('appraisalType'),
          options: [
            {
              value: '',
              label: this.props.translate('select') + this.props.translate('appraisalType')
            }
          ]
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      effective_date: {
        label: this.props.translate('effectiveDate'),
        elementType: 'datePicker',
        elementConfig: {
          type: 'text'
        },
        value: null,
        validation: {
          required: true,
          isDate: true,
          type: 'date'
        },
        valid: false,
        touched: false,
        error: null
      }
    },
    set_weight: {
      value: [],
      param: null
    },
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: [
            {
              value: '',
              label: this.props.translate('select') + this.props.translate('company')
            }
          ]
        }
      },
      criteria_id: {
        label: this.props.translate('criteriaName'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('criteriaName'),
          options: [
            {
              value: '',
              label: this.props.translate('select') + this.props.translate('criteriaName')
            }
          ]
        }
      }
    },
    updateProps: {
      selectedRecord: this.props.selectedRecord,
      companyOptions: this.props.companyOptions,
      appraisalTypeOptions: this.props.appraisalTypeOptions,
      filterCompany: this.props.filterCompany,
      filterCriteria: this.props.filterCriteria
    },
    data: [],
    save: true,
    valid: false
  }

  rowActions = [
    {
      icon: () => <Add />,
      onClick: () => this.openModalHandler('add'),
      isFreeAction: true,
      disabled: !this.props.pagePermission?.is_add
    },
    {
      icon: () => <Edit fontSize={'small'} />,
      tooltip: this.props.translate('edit') + this.props.translate('appraisalCriteria'),
      onClick: (event, rowData) => this.openModalHandler('edit', rowData.criteria_id),
      disabled: !this.props.pagePermission?.is_edit
    },
    {
      icon: () => <Delete fontSize={'small'} />,
      tooltip: this.props.translate('delete') + this.props.translate('appraisalCriteria'),
      onClick: (event, rowData) => this.openModalHandler('delete', rowData.criteria_id),
      disabled: !this.props.pagePermission?.is_delete
    }
  ]

  tableStructure = [
    {
      field: 'index',
      title: '#',
      width: 70
    },
    {
      field: 'criteria_name',
      title: this.props.translate('criteriaName'),
      type: 'string'
    },
    {
      field: 'company_name',
      title: this.props.translate('company'),
      type: 'string'
    },
    {
      field: 'effective_date',
      title: this.props.translate('effectiveDate'),
      type: 'string'
    }
  ]

  componentDidMount() {
    this.props.fetchCriteria()
    this.props.fetchOptions()
  }
  componentDidUpdate(prevprops) {
    if (prevprops.success !== this.props.success && this.props.success) {
      this.clearModal()
    }
  }
  static getDerivedStateFromProps = (props, state) => {
    let updatedState = {}
    let { updateProps } = state
    const updateOptions = (stateId, propsId, attr) => {
      const inputGroups = state.inputGroups
      const targetLevelItem = inputGroups[stateId]
      let [attrId, attrName, attrPlaceHolder] = attr

      updatedState = updateObject(updatedState, {
        inputGroups: updateObject(inputGroups, {
          [stateId]: updateFormOptions(
            props[propsId],
            targetLevelItem,
            attrId,
            attrId,
            attrName,
            attrPlaceHolder
          )
        }),
        updateProps: updateObject(updateProps, {
          [propsId]: props[propsId]
        })
      })
    }
    const updateFilter = (stateId, propsId, attr) => {
      let [attrId, attrName] = attr

      updatedState = updateObject(updatedState, {
        filterControls: updateObject(state.filterControls, {
          [stateId]: updateFilterOptions(
            props[propsId],
            state.filterControls[stateId],
            attrId,
            attrId,
            attrName,
            null,
            null,
            state.filterControls[stateId].value
          )
        }),
        updateProps: updateObject(updateProps, {
          [propsId]: props[propsId]
        })
      })
    }
    if (props.companyOptions !== updateProps.companyOptions) {
      updateOptions('company_id', 'companyOptions', [
        'company_id',
        { code: 'company_code', name: 'company_name' },
        'Select Company'
      ])
      updateFilter('company_id', 'companyOptions', [
        'company_id',
        { code: 'company_code', name: 'company_name' }
      ])
    }

    if (props.appraisalTypeOptions !== updateProps.appraisalTypeOptions) {
      updateOptions('appraisal_type_id', 'appraisalTypeOptions', [
        'value_list_id',
        { code: 'value_list_code', name: 'value_list_name' },
        'Select Appraisal Type'
      ])
    }

    if (props.filterCriteria !== updateProps.filterCriteria) {
      updateFilter('criteria_id', 'filterCriteria', ['criteria_id', 'criteria_name'])
    }
    if (props.selectedRecord !== updateProps.selectedRecord && props.selectedRecord) {
      let newOrgData = Object.entries(state.inputGroups).reduce(
        (organizationGroups, organization) => {
          let [formKey, formAttrs] = organization
          let value = ''
          let valid = false
          let touched = false
          let errorMessage = null
          if (!formAttrs.validation || !formAttrs.validation.required) {
            valid = true
          }
          if (props.selectedRecord && props.selectedRecord[formKey]) {
            value = props.selectedRecord[formKey]
            if (formAttrs.elementType === 'datePicker') {
              value = new Date(props.selectedRecord[formKey])
            } else if (formAttrs.elementType === 'newselect') {
              value = getSelectvalue(value, state.inputGroups[formKey].elementConfig.options)
            }
            let { isValid, error } = checkValidity(value, formAttrs.validation, formAttrs.label)

            valid = isValid
            errorMessage = error
          }

          const newOrgAttrs = {
            ...formAttrs,
            value: value,
            valid: valid,
            error: errorMessage,
            touched: touched
          }

          return updateObject(organizationGroups, {
            [formKey]: { ...newOrgAttrs }
          })
        },
        {}
      )
      let { company_id, appraisal_type_id } = props.selectedRecord

      let param = {
        company_id,
        appraisal_type_id
      }
      let { level_structures } = props.selectedRecord
      level_structures = level_structures.map(res => {
        res = {
          level_group_id: res.level_group_id,
          structure_id: res.structure_id,
          weight_percent: parseInt(res.weight_percent),
          competencys: res.assessor_group_criteria.map(ass => {
            ass = {
              value_list_id: ass.assessor_group_id,
              weight_percent: parseInt(ass.weight_percent),
              level_position_group: ass.level_position_group.map(lpg => {
                lpg = {
                  case_id: lpg.case_id,
                  position_group_id: lpg.action2_position_group_id,
                  weight_percent: parseInt(lpg.weight_percent)
                }
                return lpg
              })
            }
            return ass
          })
        }
        return res
      })

      updatedState = updateObject(updatedState, {
        inputGroups: newOrgData,
        set_weight: {
          ...updatedState.set_weight,
          param,
          value: level_structures
        },
        formIsValid: true,
        updateProps: {
          ...updateProps,
          selectedRecord: props.selectedRecord
        }
      })
    }
    return updatedState
  }

  onPageChangeHandler = (e, page) => {
    const pageOptions = {
      page: page,
      perPage: this.props.pagination.perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchCriteria(payload)
  }

  onPerPageChangeHandler = perPage => {
    const pageOptions = {
      page: this.props.pagination.currentPage,
      perPage: perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchCriteria(payload)
  }

  searchInputChangeHandler = e => {
    const searchText = e.target.value
    this.setState({
      searchText: searchText
    })
  }
  clearInput = () => {
    let newFormData = Object.entries(this.state.inputGroups).reduce((formGroups, form) => {
      let [formKey, formAttrs] = form
      let newFormAttrs
      switch (formKey) {
        case 'effective_date':
          newFormAttrs = {
            ...formAttrs,
            valid: false,
            value: null
          }
          break
        default:
          newFormAttrs = {
            ...formAttrs,
            valid: false,
            value: ''
          }
          break
      }

      return {
        ...formGroups,
        [formKey]: { ...newFormAttrs }
      }
    }, {})
    this.setState({
      inputGroups: newFormData,
      set_weight: { ...this.state.set_weight, value: [], param: null }
    })
  }
  openModalHandler = (action, recordId) => {
    this.props.fetchOptions()
    if (recordId && action === 'edit') {
      this.props.fetchCriteriaById(recordId)
    }
    this.setState({
      action: action,
      actionRecordId: recordId
    })

    if (action === 'delete') {
      this.openConfirmationModal(recordId)
    } else {
      this.openModal()
    }
  }

  openModal = () => {
    this.setState({
      modalOpen: true,
      formIsValid: false
    })
  }

  closeModal = () => {
    if (this.state.action === 'edit') {
      this.clearModal()
    } else {
      this.clearModal()
      this.setState({
        modalOpen: false,
        formIsValid: false
      })
    }
  }
  clearModal = () => {
    this.props.clearSelectedRecord()
    this.clearInput()
    this.setState({
      actionRecordId: null,
      modalOpen: false,
      formIsValid: false
    })
  }

  criteriaSubmitHandler = e => {
    e.preventDefault()

    let criteriaData = Object.entries(this.state.inputGroups).reduce(
      (criteriaData, criteriaEntry) => {
        let [criteriaKey, criteriaAttrs] = criteriaEntry
        let value = ''
        if (criteriaAttrs.elementType === 'newselect') {
          value = criteriaAttrs.value?.value
        } else {
          value = criteriaAttrs.value
        }
        return { ...criteriaData, [criteriaKey]: value }
      },
      {}
    )
    let weightValue = this.state.set_weight.value.map(res => {
      res = {
        level_group_id: res.level_group_id,
        structure_id: res.structure_id,
        weight_percent: parseInt(res.weight_percent),
        competencys: res.competencys.map(com => {
          com = {
            value_list_id: com.value_list_id,
            weight_percent: parseInt(com.weight_percent),
            level_position_group: com.level_position_group.map(ch => {
              ch = {
                weight_percent: parseInt(ch.weight_percent),
                case_id: ch.case_id,
                action2_position_group_id: ch.position_group_id
              }
              return ch
            })
          }
          return com
        })
      }
      return res
    })

    criteriaData = { ...criteriaData, level_structures: weightValue }
    if (this.state.action === 'add') {
      this.props.createCriteria({ ...criteriaData }, getPageStatus(this.props.pagination, false))
    } else if (this.state.action === 'edit') {
      this.props.updateCriteria(
        this.state.actionRecordId,
        { ...criteriaData },
        getPageStatus(this.props.pagination, false)
      )
    }
  }

  inputChangeHandler = (criteriaKey, event, blur) => {
    const inputGroup = this.state.inputGroups
    const criteriaItem = inputGroup[criteriaKey]

    let inputValue = ''

    switch (criteriaItem.elementType) {
      case 'newselect':
        inputValue = event
        break
      case 'datePicker':
        inputValue = event
        break
      case 'checkbox':
      default:
        inputValue = event.target.value
        break
    }

    const { isValid, error } = checkValidity(
      inputValue,
      criteriaItem.validation,
      criteriaItem.label
    )

    const updatedCriteriaItem = {
      ...criteriaItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }
    const updateGroup = { ...inputGroup, [criteriaKey]: updatedCriteriaItem }
    let formIsValid = true
    Object.values(updateGroup).map(attr => {
      return (formIsValid = formIsValid && attr.valid)
    })
    let weight = this.state.set_weight
    let anotherKey = criteriaKey === 'company_id' ? 'appraisal_type_id' : 'company_id'
    let inputGroups = {
      ...this.state.inputGroups,
      [criteriaKey]: updatedCriteriaItem
    }

    if (
      blur &&
      inputGroups['effective_date'].value !== null &&
      inputGroups['effective_date'].valid &&
      inputGroups['criteria_name'].value !== '' &&
      inputGroups['company_id'].value !== '' &&
      inputGroups['appraisal_type_id'].value !== '' &&
      !lodash.isEmpty(this.state.inputGroups[anotherKey].value)
    ) {
      let param = {
        company_id: inputGroups['company_id'].value.value,
        appraisal_type_id: inputGroups['appraisal_type_id'].value.value
      }
      weight = {
        ...this.state.set_weight,
        param
      }
    }

    this.setState({
      inputGroups: updateObject(inputGroup, { [criteriaKey]: updatedCriteriaItem }),
      set_weight: weight,
      formIsValid: formIsValid
    })
  }
  inputTableHandler = data => {
    this.setState({
      set_weight: { ...this.state.set_weight, value: data }
    })
  }

  setAssessor = (level_group, data, compId) => {
    let newValue = this.state.set_weight.value
    let levelId = newValue.findIndex(
      res => res.level_group_id === level_group.level_group_id && res.structure_id === compId
    )
    let newData = data.map(res => {
      return {
        value_list_id: res.value_list_id,
        weight_percent: res.weight_percent,
        level_position_group: res.level_position_group
      }
    })

    newValue[levelId].competencys = newData
    this.setState({
      set_weight: {
        ...this.state.set_weight,
        value: newValue
      }
    })
  }
  closeConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: false
    })
  }

  openConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: true
    })
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  openFilterModal = () => {
    let filterControls = this.state.filterControls

    Object.entries(filterControls).map((data, key) => {
      let [datakey] = data

      return (filterControls = {
        ...filterControls,
        [datakey]: { ...filterControls[datakey], value: '' }
      })
    })

    this.props.fetchFilter()

    this.setState({
      filterModalOpen: true,
      filterControls: filterControls,
      filter: []
    })
  }
  deleteRecord = () => {
    const recordId = this.state.actionRecordId

    this.props.deleteCriteria(recordId, getPageStatus(this.props.pagination, true))

    this.closeConfirmationModal()
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls[itemKey]

    this.setState({
      filterControls: {
        ...this.state.filterControls,
        [itemKey]: {
          ...filterItem,
          value: filterValue
        }
      },
      filter: { ...this.state.filter, [itemKey]: filterValue.value }
    })
  }

  filterRecords = () => {
    // TODO fetch data from server with seleted fliter
    let param = { ...this.state.filter, page: 1, perPage: 10 }
    this.props.fetchCriteria(param)
    this.closeFilterModal()
  }

  saveData = data => {
    let checkDate = /^\d{4}-\d{2}-\d{2}$/

    let setDate = this.state.inputGroups.effective_date.value
    let check = checkDate.test(this.state.inputGroups.effective_date.value)

    if (!check) {
      setDate = moment(this.state.inputGroups.effective_date.value).format('YYYY-MM-DD')
    }

    let setData = {
      company_id: this.state.set_weight.param.company_id,
      appraisal_type_id: this.state.set_weight.param.appraisal_type_id,
      criteria_name: this.state.inputGroups.criteria_name.value,
      effective_date: setDate,
      level_structures: data
    }
    if (this.props.selectedRecord) {
      this.props.updateCriteria(
        this.props.selectedRecord.criteria_id,
        setData,
        this.props.pagination
      )
    } else {
      this.props.createCriteria(setData, this.props.pagination)
    }
  }
  inputSetWeightHandler = (alldata, appraisal_type, level_structures) => {
    // let input = this.state.inputGroups
    // let date = input.effective_date.value.format('YYYY-MM-DD')
    // let format = alldata.map(item => {
    //   let lst = item.assessors.map(ass => {
    //     let chi = ass.level_position_group.map(chi => {
    //       return {
    //         case_id : chi.case_id,
    //         action2_position_group_id: chi.position_group_id,
    //         weight_percent: chi.weight_percent
    //       }
    //     }
    //     )
    //     return {
    //       assessor_group_id: ass.value_list_id,
    //       weight_percent: ass.weight_percent,
    //       level_position_group: chi
    //     }
    //   }
    //   )
    //   return {
    //     level_group_id: item.level_group_id,
    //     structure_id: item.structure_id,
    //     weight_percent: item.weight_percent,
    //     assessors: lst
    //   }
    // })
    // this.setState({
    //   data : {
    //     company_id: this.state.inputGroups.company_id.value.key,
    //     appraisal_type_id: appraisal_type,
    //     criteria_name: input.criteria_name.value,
    //     effective_date: date,
    //     level_structures: format
    //   }
    // })
  }
  saveTest = () => {
    let save = this.state.save
    this.setState({
      save: !save
    })
  }

  checkValid = valid => {
    this.setState({
      formIsValid: valid,
      valid: valid
    })
  }

  render() {
    let criteriaLabel = <Spinner />

    if (!this.props.loadingStates.length > 0) {
      criteriaLabel = (
        <Form
          form={this.state.inputGroups}
          inputChanged={this.inputChangeHandler}
          edit={this.state.action === 'edit'}
        />
      )
    }
    const buttonGroups = (
      <div className={classes.ButtonGroup}>
        <span className={classes.Button}>
          <Button
            color={'primary'}
            clicked={() => this.saveTest()}
            // disabled={!this.state.valid}
            disabled={!this.state.formIsValid}>
            {this.props.translate('save')}
          </Button>
        </span>
        <span className={classes.Button}>
          <Button color={'default'} clicked={this.clearModal}>
            {this.props.translate('cancel')}
          </Button>
        </span>
      </div>
    )
    return (
      <Aux>
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          cancelled={this.closeConfirmationModal}
          confirmed={this.deleteRecord}
          promptText={this.props.translate('confirmDel')}
        />

        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
          loadingQueue={this.props.loadingStates}
        />
        <Alert />
        <Modal
          open={this.state.modalOpen}
          onHide={this.closeModal}
          header={
            this.props.translate(this.state.action) + this.props.translate('appraisalCriteria')
          }
          disableBackdropClick={true}
          backdropClicked={this.closeModal}
          footer={buttonGroups}
          size={'xl'}>
          <div className={classes.ModalBody}>
            {criteriaLabel}
            <SetWeight
              param={this.state.set_weight.param}
              weight={this.state.set_weight.value}
              selected={this.props.selectedRecord}
              setTmergeAssessorable={this.inputTableHandler}
              mergeAssessor={this.setAssessor}
              saveData={data => this.saveData(data)}
              inputGroup={this.state.inputGroups}
              save={this.state.save}
              saveSuccess={() => this.setState({ save: true })}
              valid={valid => this.checkValid(valid)}
              // save={(alldata, appraisal_type, level_structures) =>
              //   this.inputSetWeightHandler(
              //     alldata,
              //     appraisal_type,
              //     level_structures
              //   )
              // }
            />
          </div>
        </Modal>
        <Card>
          <CardHeader>
            <FilterBar buttonClicked={this.openFilterModal} />
          </CardHeader>
          <CardBody>
            <DataTable
              tableTitle={this.props.translate('appraisalCriteria')}
              data={this.props.data}
              structure={this.tableStructure}
              loading={this.props.loadingStates.includes('fetchCriteria')}
              pagination={this.props.pagination}
              pageChange={this.onPageChangeHandler}
              perPageChange={this.onPerPageChangeHandler}
              rowActions={this.rowActions}
            />
          </CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    pagination: state.criteria.pagination,
    data: state.criteria.records,
    success: state.criteria.success,
    selectedRecord: state.criteria.selectedRecord,
    companyOptions: state.criteria.company,
    appraisalTypeOptions: state.criteria.appraisalType,
    filterCriteria: state.criteria.filterCriteria,
    loadingStates: state.criteria.loadingStates
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchCriteria: filterOptions => dispatch(actions.fetchCriteria(filterOptions)),
    fetchCriteriaById: recordId => dispatch(actions.fetchCriteriaById(recordId)),
    clearSelectedRecord: () => dispatch(actions.clearSelectedCriteriaRecord()),
    createCriteria: (recordData, page) => dispatch(actions.createCriteria(recordData, page)),
    updateCriteria: (recordId, recordData, page) =>
      dispatch(actions.updateCriteria(recordId, recordData, page)),
    deleteCriteria: (recordId, page) => dispatch(actions.deleteCriteria(recordId, page)),
    fetchOptions: () => {
      dispatch(actions.fetchCompanyOptions())
      dispatch(actions.fetchAppraisalTypeOptions())
    },
    fetchFilter: () => {
      dispatch(actions.fetchCompanyOptions())
      dispatch(actions.fetchCriteriaOptions())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(SetupCriteria))
